module.exports = __webpack_public_path__ + "img/1.75a8a25f.png";